// @ts-ignore
var $npm: $npm = $npm || {} as $npm
